<section>
	<div class="header">
		<h2>VSO</h2>
	</div>
	<div class="uitleg">
		<div>
			Hier kun je voor alle VSO-vestigingen binnen jouw onderwijsinstelling instellen tot welk cluster de vestiging behoort, in onze
			<a href="https://cumlaude.zendesk.com/hc/nl/sections/10260110147729-Prestatieanalyse-VSO">handleiding</a> kun je hier meer over lezen.
		</div>
		<div>
			Wanneer hieronder een cluster aan een vestiging is toegewezen, kunnen voor die vestiging de percentielgrenzen voor de indicatoren van de
			prestatieanalyse worden bepaald.
		</div>
		<div>
			De onderwijsinspectie heeft de volgende 6 clusters vastgesteld:
			<ul>
				<li><b>Cluster 1:</b> Communicatie - visuele beperkingen, visueel meervoudig beperkt</li>
				<li><b>Cluster 2:</b> Communicatie - doofheid, slechthorendheid</li>
				<li><b>Cluster 2+EMB:</b> Communicatie - doofblindheid, doof meervoudig beperkt, slechthorend meervoudig beperkt</li>
				<li><b>Cluster 3:</b> Fysiek en/of medische situatie</li>
				<li><b>Cluster 3/4:</b> Leren en ontwikkelen, combinaties van fysiek of medische situatie en sociaal emotioneel ontwikkelen</li>
				<li><b>Cluster 4:</b> Sociaal emotioneel ontwikkelen</li>
			</ul>
		</div>
	</div>
	<div class="content">
		<div class="toolbar">
			<div class="selector schooljaar">
				<span>Schooljaar</span>
				<app-single-select-dropdown
					[selectedOptie]="getSelectedSchooljaar()"
					[opties]="schooljaarOptions()"
					(onOptieClicked)="schooljaar.set($event)"
					[enabled]="!dirty()"
				>
				</app-single-select-dropdown>
			</div>
			<div class="buttons">
				<app-button buttonType="secondary" [enabled]="dirty()" (clickit)="revert()">Annuleren</app-button>
				<app-button [enabled]="dirty()" (clickit)="trySave()">Opslaan</app-button>
			</div>
		</div>
		<div class="tabel">
			<div class="header">
				<div class="vestiging">Vestiging</div>
				<div class="cluster">Cluster</div>
			</div>
			@for (vestigingClusterVSO of vestigingClusterVSOs(); track vestigingClusterVSO.vestigingId) {
				<div class="row">
					<div class="vestiging">
						{{ vestigingClusterVSO.vestigingNaam }}
					</div>
					<div class="cluster">
						<app-single-select-dropdown
							[selectedOptie]="getSelectedCluster(vestigingClusterVSO.cluster)"
							[opties]="clusterOptions()"
							(onOptieClicked)="updateCluster(vestigingClusterVSO, $event)"
						>
						</app-single-select-dropdown>
					</div>
				</div>
			}
		</div>
	</div>
</section>
